import { forwardRef, Inject, Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getConnection, Repository } from 'typeorm';
import { ModuleService } from '../module/module.service';
import { BiMessage } from '../entity/bi-message.entity';
import { BiMessageModel } from './models/bi-message.model';
import { BiMessageResponse, BiMessageStatus, CommonResponse, CompanyBiMessageModel, CompanyBiMessageResponse, ErrorResponse, ExcelImportResponse, GlobalResponseObject, MessageCategoryEnum, MessageTypeEnum, PriorityEnum, TemplateCategories, WhatsappLogDto, WhatsappLogResponseModel } from '@schemax-whatsapp/shared-models';
import { Modules } from '../entity/module.entity';
import { BiMessageIdRequest } from './models/bi-message-id.request';
import { ModuleIdRequest } from '../module/models/module-id.request';
import { CompanyIdBiMsgIdRequest } from './models/company-bi-message-ids.request';
import { CompanyBiMessage } from '../entity/company-bi-message.entity';
import { CompanyIdReq, CompanyModuleIdRequest } from './models/company-module-id.request';
import { Company } from '../entity/company.entity';
import { ExcelImportAdapter } from '../../../../whatsapp-broad-cast/src/app/whatsapp-broad-cast/adapter/excel-import.adapter';
import { WhatsappLogEntity } from '../entity/whats-app-log.entity';
import { WhatsappLogRequest } from '../company/models/company-id.request';
import { WhatsAppMetaService } from '@schemax-whatsapp/shared-services/whatsapp-api'
import { Cron } from '@nestjs/schedule';
import { WhatsappLogsDto } from '../entity/repository/whatsapp-logs-dto';

@Injectable()
export class BiMessageService {
    constructor(
        @InjectRepository(WhatsappLogEntity) private whatsapplogRepo: Repository<WhatsappLogEntity>,
        @InjectRepository(BiMessage) private biMsgRepo: Repository<BiMessage>,
        @InjectRepository(CompanyBiMessage) private cbMsgRepo: Repository<CompanyBiMessage>,
        @Inject(forwardRef(() => ModuleService)) private moduleService: ModuleService,
        private ExcelAdapter: ExcelImportAdapter,
        private metaService: WhatsAppMetaService
    ) {

    }
    /**
     * 
     * @param msgReq 
     * @returns 
     */
    async createBiMessage(msgReq: BiMessageModel, isStatusUpdate?: boolean): Promise<BiMessageResponse> {
        const module = await this.moduleService.getModuleByModuleId(msgReq.moduleId);
        if (!module) {
            throw new ErrorResponse(0, 'No module exist for the company');
        }
        const msgEntity = this.convertBiMessageModelToEntity(msgReq.moduleId, msgReq.roleEscalation, msgReq.activity, msgReq.impact, msgReq.rule, msgReq.priority, msgReq.messageType, msgReq.messageCategory, msgReq.qdc, msgReq.username, msgReq.messageBody, msgReq.templateName, msgReq.messageStatus, msgReq.language, msgReq.footer);
        const savedEntity = await this.biMsgRepo.save(msgEntity);
        const msgModel = this.convertBiMessageEntityToModel(savedEntity.biMessageId, msgReq.moduleId, null, msgEntity.roleEscalation, msgEntity.activity, savedEntity.impact, savedEntity.rule, savedEntity.messageCategory, savedEntity.priority, savedEntity.messageType, msgEntity.qdc, savedEntity.createdUser, msgEntity.messageBody, msgEntity.templateName, msgEntity.messageStatus, msgEntity.language, msgEntity.footer);
        console.log('-------------------msg saved------------------')
        return new BiMessageResponse(true, 0, 'Bi Message saved successfully', [msgModel]);

    }

    /**
     * 
     * @param msgReq 
     * @returns 
     */
    async updateBiMessage(msgReq: BiMessageModel): Promise<BiMessageResponse> {
        // check if the bi message record
        const biMessage = await this.biMsgRepo.findOne({ where: { biMessageId: msgReq.biMessageId } });
        if (!biMessage) {
            throw new ErrorResponse(0, 'No Bi Message exist to update');
        }
        // just reassign the values whatever coming from the ui and update the record
        await this.biMsgRepo.update({ biMessageId: msgReq.biMessageId }, { impact: msgReq.impact, rule: msgReq.rule, priority: msgReq.priority, messageType: msgReq.messageType, updatedUser: msgReq.username, messageBody: msgReq.messageBody, templateName: msgReq.templateName, messageStatus: msgReq.messageStatus });
        // get the saved entity
        const savedEntity = await this.biMsgRepo.findOne({ where: { biMessageId: msgReq.biMessageId }, relations: ['role'] });
        const msgModel = this.convertBiMessageEntityToModel(savedEntity.biMessageId, msgReq.moduleId, null, savedEntity.roleEscalation, savedEntity.activity, savedEntity.impact, savedEntity.rule, savedEntity.messageCategory, savedEntity.priority, savedEntity.messageType, savedEntity.qdc, savedEntity.createdUser, savedEntity.messageBody, savedEntity.templateName, savedEntity.messageStatus);
        return new BiMessageResponse(true, 0, 'Bi Message updated successfully', [msgModel]);
    }

    /**
     * @param moduleId 
     * @param roleEscalation 
     * @param activity 
     * @param impact 
     * @param rule 
     * @param priority 
     * @param msgtype 
     * @param category 
     * @param qdc 
     * @param username 
     * @returns 
     */
    convertBiMessageModelToEntity(moduleId: number, roleEscalation: string, activity: string, impact: string, rule: string, priority: PriorityEnum, msgtype: MessageTypeEnum, category: TemplateCategories, qdc: string, username: string, messageBody: string, templateName: string, messageStatus: BiMessageStatus, language?: string, footer?: string): BiMessage {
        const biMessage = new BiMessage();
        biMessage.module = new Modules(); biMessage.module.moduleId = moduleId;
        biMessage.messageType = msgtype;
        biMessage.messageCategory = category;
        biMessage.priority = priority;
        biMessage.rule = rule;
        biMessage.impact = impact;
        biMessage.createdUser = username;
        biMessage.roleEscalation = roleEscalation;
        biMessage.activity = activity;
        biMessage.qdc = qdc;
        biMessage.messageBody = messageBody
        biMessage.templateName = templateName
        biMessage.messageStatus = messageStatus
        biMessage.language = language;
        biMessage.footer;
        return biMessage;
    }

    /**
     * 
     * @param biMsgId 
     * @param moduleId 
     * @param moduleName 
     * @param roleEscalation 
     * @param activity 
     * @param impact 
     * @param rule 
     * @param category 
     * @param priority 
     * @param msgType 
     * @param qdc 
     * @param username 
     * @returns 
     */
    convertBiMessageEntityToModel(biMsgId: number, moduleId: number, moduleName: string, roleEscalation: string, activity: string, impact: string, rule: string, category: TemplateCategories, priority: PriorityEnum, msgType: MessageTypeEnum, qdc: string, username: string, messageBody: string, templateName: string, messageStatus: BiMessageStatus, language?: string, footer?: string): BiMessageModel {
        const biMsg = new BiMessageModel(biMsgId, moduleId, moduleName, roleEscalation, activity, msgType, category, priority, impact, rule, qdc, username, messageBody, templateName, messageStatus, language, footer);
        return biMsg;
    }

    /**
     * 
     * @param msgReq 
     * @returns 
     */
    async deleteBiMessage(biMsgIdReq: BiMessageIdRequest): Promise<BiMessageResponse> {
        // check if the bi message record
        const biMessage = await this.biMsgRepo.findOne({ where: { biMessageId: biMsgIdReq.biMessageId } });
        if (!biMessage) {
            throw new ErrorResponse(0, 'No Bi Message exist to update');
        }
        // check if this msg was mapped to any company
        const companyMsg = await this.cbMsgRepo.findOne({ where: { biMessageId: biMsgIdReq.biMessageId } });
        if (companyMsg) {
            throw new ErrorResponse(0, 'The Message is mapped to a company. You cannot delete this');
        }
        await this.biMsgRepo.delete({ biMessageId: biMsgIdReq.biMessageId });
        return new BiMessageResponse(true, 0, 'Bi Message deleted successfully');
    }


    /**
     * 
     * @param moduleIdReq 
     * @returns 
     */
    async getAllBiMessagesForModule(moduleIdReq: ModuleIdRequest): Promise<BiMessageResponse> {
        const moduleId = moduleIdReq.moduleId;
        // get all the bi messages for the company and role id
        let findConditions = {};
        if (moduleId) {
            const module = new Modules();
            module.moduleId = moduleId;
            findConditions = { module: module };
        }
        const biMessages = await this.biMsgRepo.find({ where: findConditions, relations: ['module'], order: { biMessageId: 'ASC' } });
        const biMessageModels: BiMessageModel[] = [];
        for (const msg of biMessages) {
            const biMsgModel = new BiMessageModel(msg.biMessageId, msg.module.moduleId, msg.module.moduleName, msg.roleEscalation, msg.activity, msg.messageType, msg.messageCategory, msg.priority, msg.impact, msg.rule, msg.qdc, msg.createdUser, msg.messageBody, msg.templateName, msg.messageStatus);
            biMessageModels.push(biMsgModel);
        }
        return new BiMessageResponse(true, 0, 'Bi messages retrieved successfully', biMessageModels);
    }

    /**
     * 
     * @param moduleId 
     * @returns 
     */
    async checkIfBiMessageExistForModuleIdAndThrowErrorIfExist(moduleId: number): Promise<boolean> {
        const moduleEnt = new Modules();
        moduleEnt.moduleId = moduleId;
        const biMsgRec = await this.biMsgRepo.findOne({ where: { module: moduleEnt } });
        if (biMsgRec) {
            throw new ErrorResponse(0, 'Bi Messages are defined for this module');
        }
        return biMsgRec ? true : false;
    }

    // --------------------  Company Bi Messages --------------------------
    /**
     * 
     * @param companyIdBiMsgIdReq 
     * @returns 
     */
    async mapBiMessageToCompany(companyIdBiMsgIdReq: CompanyIdBiMsgIdRequest): Promise<GlobalResponseObject> {
        const companyId = companyIdBiMsgIdReq.companyId;
        const moduleId = companyIdBiMsgIdReq.moduleId;
        const cbmEnts: CompanyBiMessage[] = [];

        const company = new Company(); company.companyId = companyId;
        const module = new Modules(); module.moduleId = moduleId;
        for (const msgId of companyIdBiMsgIdReq.biMsgIds) {
            // check if this message is already a part of the current company
            let msgExistCount = 0;
            // const msgExistCount = await this.cbMsgRepo.count({ where: { biMessageId: msgId, company: company }});
            if (msgExistCount == 0) {
                // get the message from the BI message and insert it into the company bi message entity
                const biMessage = await this.getBiMessageRecord(msgId);
                const cbmEnt = this.convertCompanyBiMessageModelToEntity(biMessage.biMessageId, companyId, moduleId, biMessage.roleEscalation, biMessage.activity, biMessage.impact, biMessage.rule, biMessage.priority, biMessage.messageType, companyIdBiMsgIdReq.username, biMessage.messageCategory, biMessage.qdc, biMessage.messageBody, biMessage.templateName, biMessage.messageStatus);
                cbmEnts.push(cbmEnt);
            }
        }
        await this.cbMsgRepo.delete({ company: company, module: module });
        await this.cbMsgRepo.save(cbmEnts, { reload: false });
        return new GlobalResponseObject(true, 0, 'Messages mapped to the company successfully');
    }

    /**
     * 
     * @param biMessageId 
     * @param companyId 
     * @param moduleId 
     * @param roleEscalation 
     * @param activity 
     * @param impact 
     * @param rule 
     * @param priority 
     * @param msgType 
     * @param username 
     * @returns 
     */
    convertCompanyBiMessageModelToEntity(biMessageId: number, companyId: number, moduleId: number, roleEscalation: string, activity: string, impact: string, rule: string, priority: PriorityEnum, msgType: MessageTypeEnum, username: string, msgCategory: TemplateCategories, qdc: string, messageBody: string, templateName: string, messageStatus: BiMessageStatus): CompanyBiMessage {
        const biMessage = new CompanyBiMessage();
        biMessage.module = new Modules(); biMessage.module.moduleId = moduleId;
        biMessage.company = new Company(); biMessage.company.companyId = companyId;
        biMessage.messageCode = companyId + '-' + biMessageId;
        biMessage.biMessageId = biMessageId;
        biMessage.messageType = msgType;
        biMessage.priority = priority;
        biMessage.rule = rule;
        biMessage.impact = impact;
        biMessage.createdUser = username;
        biMessage.roleEscalation = roleEscalation;
        biMessage.activity = activity;
        biMessage.qdc = qdc;
        biMessage.messageCategory = msgCategory;
        biMessage.messageBody = messageBody;
        biMessage.templateName = templateName;
        biMessage.messageStatus = messageStatus;
        return biMessage;
    }

    /**
     * 
     * @param id 
     * @returns 
     */
    async getBiMessageRecord(id: number): Promise<BiMessage> {
        return await this.biMsgRepo.findOne({ where: { biMessageId: id }, relations: ['module'] });
    }

    /**
     * 
     * @param companyModuleIdReq 
     */
    async getAllCompanyBiMessagesForModule(companyModuleIdReq: CompanyModuleIdRequest): Promise<CompanyBiMessageResponse> {
        // const companyId =  companyModuleIdReq.companyId;
        // const moduleId = companyModuleIdReq.moduleId;
        // const company = new Company(); company.companyId = companyId;
        // const module = new Modules(); module.moduleId = moduleId;
        let whatsappbiMessages = this.cbMsgRepo.createQueryBuilder("CompanyBiMessage").select("template_name as templateName,cbm_id as companyBiMessageId,bi_message_id as biMessageId,message_code as messageCode,company.company_id as companyId,company.company_name as companyName,module.module_id as moduleId,module.module_name as moduleName,role_escalation as roleEscalation,activity ,message_type as messageType,message_category as messageCategory,priority,impact,qdc,CompanyBiMessage.created_user as createdUser,message_body as messageBody,template_name as templateName,message_status as  messageStatus")
            .leftJoinAndSelect('CompanyBiMessage.company', 'company')
            .leftJoinAndSelect('CompanyBiMessage.module', 'module')
            .where("cbm_id >0")
        console.log(whatsappbiMessages);
        if (companyModuleIdReq.companyId) {
            whatsappbiMessages.andWhere(`company.company_id=${companyModuleIdReq.companyId}`)
                .orderBy("bi_message_id", "ASC")
        } if (companyModuleIdReq.companyId && companyModuleIdReq.moduleId) {
            whatsappbiMessages.andWhere(`company.company_id=${companyModuleIdReq.companyId} and module.module_id=${companyModuleIdReq.moduleId}`)
                .orderBy("bi_message_id", "ASC")
        }
        const biMessages = await whatsappbiMessages.getRawMany();

        // const biMessages = await this.cbMsgRepo.find({ where: { company: company, module: module}, relations: ['module', 'company'], order: { biMessageId: 'ASC'} });
        const companyBiMsgs: CompanyBiMessageModel[] = [];
        for (const cMsg of biMessages) {
            const model = new CompanyBiMessageModel(cMsg.companyBiMessageId, cMsg.biMessageId, cMsg.messageCode, cMsg.companyId, cMsg.companyName, cMsg.moduleId, cMsg.moduleName, cMsg.roleEscalation, cMsg.activity, cMsg.messageType, cMsg.messageCategory, cMsg.priority, cMsg.impact, cMsg.rule, cMsg.qdc, cMsg.createdUser, cMsg.messageBody, cMsg.templateName, cMsg.messageStatus);
            companyBiMsgs.push(model);
        }
        return new CompanyBiMessageResponse(true, 0, 'Company bi messages retrieved successfully', companyBiMsgs)
    }

    async biMessageStatusApproval(req: BiMessageModel, isUpdate: boolean): Promise<BiMessageResponse> {
        try {
            // const saveData = await this.createBiMessage(req,true)

            await this.biMsgRepo.update({ biMessageId: req.biMessageId }, { messageStatus: BiMessageStatus.APPROVED });
            await this.cbMsgRepo.update({ biMessageId: req.biMessageId }, { messageStatus: BiMessageStatus.APPROVED })
            const response = new BiMessageResponse(true, isUpdate ? 0 : 0, isUpdate ? 'Message Status Updated Succesfully' : 'Created Succesfully')
            return response

        } catch (error) {
            return error;
        }
    }

    async getwhatsappLogsreport(req:WhatsappLogRequest):Promise<CommonResponse>{
        try{
         let query =   this.whatsapplogRepo.createQueryBuilder("WhatsappLogEntity")
         .select("WhatsappLogEntity.company_id as companyId,WhatsappLogEntity.module_id as moduleId,log_id AS logId,COUNT(*) as msgcount,contact_no as contactNo,template_name as templateName,project_name as projectName,DATE(genereted_at) as generatedAt , HOUR(genereted_at) as hour , MINUTE(genereted_at) as minute,module.module_name as moduleName,company.company_name as companyName")
         .leftJoin(Modules,'module',`module.module_id=WhatsappLogEntity.module_id`)
         .leftJoin(Company,'company',`company.company_id=WhatsappLogEntity.company_id`)
         .where(` DATE(genereted_at) between '${req.fromDate}' and '${req.toDate}'`)
         if(req.companyId){
            query.andWhere(`WhatsappLogEntity.company_id=${req.companyId}`)
            .groupBy("contact_no,template_name,project_name,WhatsappLogEntity.company_id,WhatsappLogEntity.module_id,DATE(genereted_at)")
            .orderBy("COUNT(*)","DESC")
         }
         if(req.companyId && req.moduleId){
            query.andWhere(`WhatsappLogEntity.company_id=${req.companyId} and WhatsappLogEntity.module_id=${req.moduleId}`)
            .groupBy("contact_no,template_name,project_name,WhatsappLogEntity.company_id,WhatsappLogEntity.module_id,DATE(genereted_at)")
            .orderBy("COUNT(*)","DESC")
         }
        // if(req.fromDate && req.toDate ){
        //     query.andWhere(`DATE(genereted_at) between '${req.fromDate}' and '${req.toDate}'`)
        //   .groupBy("contact_no,template_name,project_name,company_id,module_id,DATE(genereted_at)")
        //  .orderBy("COUNT(*)","DESC")
        // }
        else{
            query.groupBy("contact_no,template_name,project_name,WhatsappLogEntity.company_id,WhatsappLogEntity.module_id,DATE(genereted_at)")
         .orderBy("COUNT(*)","DESC") 

            }
            const data = await query.getRawMany();
            console.log(data)
            if (data.length > 0) {
                return new CommonResponse(true, 1000, 'Whatsapplogs data Retrived Sucesfully', data)
            } else {
                return new CommonResponse(false, 1000, 'no data found', data)
            }
        } catch (err) {
            return err
        }
    }

    async getAllModulesandCompany(req: CompanyIdReq): Promise<CompanyBiMessageResponse> {
        let biMessages = await this.cbMsgRepo.createQueryBuilder("CompanyBiMessage").select("company.company_id as companyId,company.company_name as companyName,module.module_id as moduleId,module.module_name as moduleName,module.module_desc as moduleDes,module.created_user as user")
            .leftJoinAndSelect('CompanyBiMessage.company', 'company')
            .leftJoinAndSelect('CompanyBiMessage.module', 'module')
            .where(`company.company_id=${req.companyId}`)
            .groupBy("company.company_id,module.module_id")
            .orderBy("bi_message_id", "ASC")
            .getRawMany();
        if (biMessages) {
            return new CompanyBiMessageResponse(true, 0, 'Company bi messages retrieved successfully', biMessages)
        } else {
            return new CompanyBiMessageResponse(false, 0, 'no data found', biMessages)

        }
    }
    async getAllModuleForwhtsappLogs(req: CompanyIdReq): Promise<CommonResponse> {
        const query = await this.whatsapplogRepo.createQueryBuilder('WhatsappLogEntity')
            .select('WhatsappLogEntity.company_id as companyId,WhatsappLogEntity.module_id as moduleId,m.module_name AS moduleName,c.company_name AS companyName')
            .leftJoin('module', 'm', 'm.module_id=WhatsappLogEntity.module_id')
            .leftJoin('company', 'c', 'c.company_id=WhatsappLogEntity.company_id')
            .where(`WhatsappLogEntity.company_id=${req.companyId}`)
            .groupBy('WhatsappLogEntity.company_id,WhatsappLogEntity.module_id')
            .getRawMany();
        if (query.length > 0) {
            return new CommonResponse(true, 1000, 'Data Retrived Sucessfully', query)

        } else {
            return new CommonResponse(false, 1000, 'Data Retrived Sucessfully', query)

        }
    }

    @Cron('0 */5 * * *')
    async getTemplates(): Promise<CommonResponse> {
        const templates = await this.metaService.getTemplates()
        const data = templates.data
        console.log('data', data)
        for (let i = 0; i < data.length; i++) {
            if (data[i].status === 'APPROVED') {
                await this.biMsgRepo.update({ templateName: data[i].name, messageStatus: BiMessageStatus.WAITING_FOR_APPROVAL }, { messageStatus: BiMessageStatus.APPROVED })
            } else if (data[i].status === 'REJECTED') {
                await this.biMsgRepo.update({ templateName: data[i].name, messageStatus: BiMessageStatus.WAITING_FOR_APPROVAL }, { messageStatus: BiMessageStatus.REJECTED })
            }
        }
        return new CommonResponse(true, 0, 'Templates updated successfully')
    }
    async createWhatappLog(dto:WhatsappLogsDto): Promise<boolean> {
        console.log("Service");
        await this.whatsapplogRepo
        .createQueryBuilder()
        .insert()
        .into(WhatsappLogEntity)
        .values([
            {contactNo:dto.contactNo,templateName:dto.templateName,projectName:dto.projectName,companyId:dto.companyId,moduleId:dto.moduleId}
         ])
        .execute();
        return true;
      }
    }



